import { FENIX_INHERIT_COUNTRY_CODE } from '../../../components/HighCharts/utils';

// Field of the first "Inherit country code" filter in any series, or null.
// Published charts resolve that placeholder from the page's country; the
// builder has no page, so the preview offers a country picker instead.
export const findInheritCountryFilterField = (config = {}) => {
    for (const series of config?.series || []) {
        const match = (series.filterParams || []).find(
            (f) => f && f.value === FENIX_INHERIT_COUNTRY_CODE
        );
        if (match) return match.field;
    }
    return null;
};

export const configHasInheritCountryFilter = (config = {}) =>
    findInheritCountryFilterField(config) !== null;

export const normalizeFilterParams = (filterParams = []) => {
    if (Array.isArray(filterParams)) {
        return filterParams.filter(Boolean).map((filter) => ({
            ...filter,
            op: filter.op || filter.operator || 'eq',
        }));
    }

    if (filterParams && typeof filterParams === 'object') {
        return Object.entries(filterParams).map(([field, value]) => ({
            field,
            op: 'eq',
            value,
        }));
    }

    return [];
};

export const normalizeConfigFilterParams = (config = {}) => {
    const safeConfig = config || {};
    return {
        ...safeConfig,
        series: Array.isArray(safeConfig.series)
            ? safeConfig.series.map((series) => ({
                  ...series,
                  filterParams: normalizeFilterParams(series.filterParams),
              }))
            : safeConfig.series,
    };
};
